import script from "./ForgotPass.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPass.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPass.vue?vue&type=style&index=0&id=4c566278&lang=scss"

const __exports__ = script;

export default __exports__